import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { set } from "lodash";
import { KEYS, PROCESS_URL_PARAMS } from "utils/constants";
import { hundredYearsAgoStart } from "utils/helpers/date";
import { resolveDomainSignInUserId } from "./domainSignInUser";

dayjs.extend(customParseFormat);

const ISO_DATE_FORMAT = "YYYY-MM-DD";
const TRACKON_REQID_MAX_LENGTH = 255;

const parseBirthDate = (value) => {
  const date = dayjs(value, ISO_DATE_FORMAT, true);
  if (!date.isValid()) return null;
  if (date.isAfter(dayjs(), "day")) return null;
  if (date.isBefore(hundredYearsAgoStart, "day")) return null;
  return date.format(ISO_DATE_FORMAT);
};

const parseTrackonReqid = (value) =>
  value.length <= TRACKON_REQID_MAX_LENGTH ? value : null;

const store = (key) => (value) => localStorage.setItem(key, value);

const PROCESS_PARAMS = {
  [PROCESS_URL_PARAMS.PROJECT_ID]: { persist: store(KEYS.PROJECT_ID) },
  [PROCESS_URL_PARAMS.STATUS_ID]: { persist: store(KEYS.STATUS_ID) },
  [PROCESS_URL_PARAMS.LINK_ID]: { persist: store(KEYS.LINK_ID) },
  [PROCESS_URL_PARAMS.USER_ID]: {},
  [PROCESS_URL_PARAMS.BIRTH_DATE]: {
    parse: parseBirthDate,
    inject: "contact.user.birthDate",
  },
  [PROCESS_URL_PARAMS.TRACKON_REQID]: {
    parse: parseTrackonReqid,
    inject: "fields.trackon.reqid",
  },
};

const readRawParam = (queryParams, key) => {
  const value = queryParams.get(key);
  if (!value || value === "undefined") return null;
  return value.trim() || null;
};

export const readProcessParams = (queryParams) =>
  Object.entries(PROCESS_PARAMS).reduce((acc, [key, { parse }]) => {
    const raw = readRawParam(queryParams, key);
    const value = raw && (parse ? parse(raw) : raw);
    return value ? { ...acc, [key]: value } : acc;
  }, {});

export const persistProcessParams = (values) =>
  Object.entries(values).forEach(([key, value]) => {
    const persist = PROCESS_PARAMS[key]?.persist;
    if (persist && value) persist(value);
  });

export const buildProjectInitialValues = (values) =>
  Object.entries(values).reduce((acc, [key, value]) => {
    const inject = PROCESS_PARAMS[key]?.inject;
    if (!inject) return acc;
    return typeof inject === "function"
      ? inject(acc, value)
      : set(acc, inject, value);
  }, {});

export const resolveLinkId = (values) =>
  values[PROCESS_URL_PARAMS.LINK_ID] || localStorage.getItem(KEYS.LINK_ID);

export const resolveGuestUserId = (values) =>
  resolveDomainSignInUserId(
    values[PROCESS_URL_PARAMS.USER_ID],
    localStorage.getItem(KEYS.GUEST_USER_ID),
  );

export const persistGuestUserId = (userId) => {
  if (userId) return localStorage.setItem(KEYS.GUEST_USER_ID, userId);
  localStorage.removeItem(KEYS.GUEST_USER_ID);
};
